import { IconFacebook } from '../../../icons/IconFacebook/IconFacebook'
import { IconTwitter } from '../../../icons/IconTwitter/IconTwitter'
import { IconWhatsapp } from '../../../icons/IconWhatsapp/IconWhatsapp'
import { IconEmail } from '../../../icons/IconEmail/IconEmail'
import { IconReddit } from '../../../icons/IconReddit/IconReddit'
import { IconLink } from '../../../icons/IconLink/IconLink'
import { ShareOption } from '@news-mono/web-common'

export const getIconComponent = (shareOption: ShareOption) => {
    switch (shareOption) {
        case 'facebook':
            return IconFacebook
        case 'twitter':
            return IconTwitter
        case 'whatsapp':
            return IconWhatsapp
        case 'email':
            return IconEmail
        case 'reddit':
            return IconReddit
        case 'clipboard':
            return IconLink
        default:
            return
    }
}
